module.exports = __webpack_public_path__ + "img/auditoria2.8e875db9.svg";